import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'main-tai-chi-walking': {
			// ?safe&mock-data&utm_source=google&country=US&area=main-tai-chi-walking&exp=web_welcome_for_google_tai_chi_walking_gs~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_welcome_for_google_tai_chi_walking_gs'),
			},
		},
	},
]

export default config
